var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { useTranslation } from 'react-i18next';
import { AppBar, Box, Stack, Toolbar } from '@mui/material';
import AccurityIconButton from '../../buttons/components/AccurityIconButton';
var withHttp = function (url) { return url.replace(/^(?:(.*:)?\/\/)?(.*)/i, function (match, schemma, nonSchemmaUrl) { return schemma ? match : "http://" + nonSchemmaUrl; }); };
var LOGO_SX = { height: '32px', lineHeight: 0 };
var APPBAR_SX = { alignItems: 'center', columnGap: 2, paddingX: 2, paddingY: 0 };
var CLICKABLE_LOGO_SX = __assign(__assign({}, LOGO_SX), { cursor: 'pointer' });
var AccurityAppBar = function (_a) {
    var onMenuClick = _a.onMenuClick, _b = _a.isMenuExpanded, isMenuExpanded = _b === void 0 ? false : _b, appLogoSrc = _a.appLogoSrc, onAppLogoClick = _a.onAppLogoClick, customLogoSrc = _a.customLogoSrc, customLogoLink = _a.customLogoLink, additionalLeftContent = _a.additionalLeftContent, children = _a.children;
    var t = useTranslation().t;
    var noLink = !customLogoLink;
    var renderMenuButton = function () { return (React.createElement(AccurityIconButton, { "aria-label": "main-menu-button", iconName: isMenuExpanded ? 'mui:MenuOpen' : 'mui:Menu', title: t(isMenuExpanded ? 'appBar.closeMenu' : 'appBar.openMenu'), onClick: onMenuClick })); };
    var renderAppLogo = function () { return (React.createElement(Box, { "aria-label": "app-logo", component: "img", alt: "Application logo", src: appLogoSrc, sx: CLICKABLE_LOGO_SX, onClick: onAppLogoClick })); };
    var renderCustomLogo = function () {
        if (customLogoSrc) {
            return React.createElement(Box, { "aria-label": "custom-logo", component: "img", alt: "Custom logo", src: customLogoSrc, sx: noLink ? LOGO_SX : CLICKABLE_LOGO_SX, onClick: function () {
                    if (customLogoLink) {
                        window.open(withHttp(customLogoLink), '_blank');
                    }
                } });
        }
        return null;
    };
    return (React.createElement(AppBar, { position: "static" },
        React.createElement(Toolbar, { disableGutters: true, sx: { justifyContent: 'space-between' } },
            React.createElement(Stack, __assign({ direction: "row", "aria-label": "app-bar-left-content" }, APPBAR_SX),
                renderMenuButton(),
                renderAppLogo(),
                renderCustomLogo(),
                additionalLeftContent),
            React.createElement(Stack, __assign({ direction: "row", "aria-label": "app-bar-right-content" }, APPBAR_SX), children))));
};
export default AccurityAppBar;
//# sourceMappingURL=AppBar.js.map